import React, { useMemo } from "react";
import ContainerContent from "../Container/ContainerContent";
import { API, Auth, Storage } from "aws-amplify";
import { useState } from "react";
import Lottie from "react-lottie";
import { useSelector } from "react-redux";
import {
  getCurrentLocalDateTime,
  months,
  pad,
} from "../../utils/getLocalDateTime";
import { ToastContainer, toast } from "react-toastify";
import CSVReader from "react-csv-reader";
import Loading from "../../animation/loading.json";
import classNames from "classnames";
import { EmitterStatus } from "../../event";
import Select from "react-select";
import Swal from "sweetalert2";
import moment from "moment";

const today = getCurrentLocalDateTime();

function SapMain() {
  const initialFormPayment = {
    paid_amount: 0,
    loan_kbank_id: "",
    transactionId: "",
  };
  const [selectMonth, setSelectMonth] = useState(pad(today.month));
  const [selectDate, setSelectDate] = useState(pad(today.date));
  const [selectYear, setSelectYear] = useState(today.year);
  const [selectHour, setSelectHour] = useState(pad(today.hours));
  const [selectMinute, setSelectMinute] = useState(pad(today.minutes));
  const [loadingImport, setLoadingImport] = useState(false);
  const [passwordSyncDelete, setPasswordSyncDelete] = useState();
  const [checkPassword, setCheckPassword] = useState(false);
  const [passwordAutoDate, setPasswordAutoDate] = useState();
  const [checkPasswordAutoDate, setCheckPasswordAutoDate] = useState();
  const [sapCreate, setSapCreate] = useState("");
  const [arClear, setArClear] = useState("");
  const [loadingCreate, setLoadingCreate] = useState(false);
  const [loadingArClear, setLoadingArClear] = useState(false);
  const [checkPasswordArClear, setCheckPasswordArClear] = useState("");
  const [passwordArClear, setPasswordArClear] = useState("");
  const [formPayment, setFormPayment] = useState(initialFormPayment);

  const { user } = useSelector((state) => state.initializeApp);

  const importOptions = {
    header: true,
    dynamicTyping: true,
    skipEmptyLines: true,
  };
  const years = new Array(3).fill(today.year).map((year, index) => {
    const value = year - index;
    return {
      label: value,
      value,
    };
  });

  const optionsYears = years;

  const optionsMonths = months
    // .slice(0, today.month)
    .map((_, index) => {
      return {
        label: `${pad(index + 1)}`,
        value: `${pad(index + 1)}`,
        index,
      };
    })
    .reverse();

  const dayOfMonth = months[Number(selectMonth - 1)].days;

  const optionsDates = new Array(dayOfMonth)
    .fill(dayOfMonth)
    // .slice(0, +selectDate)
    .map((_, index) => {
      const value = index + 1;
      return {
        label: `${pad(value)}`,
        value: `${pad(value)}`,
        index,
      };
    })
    .reverse();

  const optionsHours = useMemo(() => {
    return [{ label: "00", value: "00" }]
      .concat(
        new Array(23)
          .fill(23)
          // .slice(0, selectDate < +today.date ? 23 : +today.hours)
          .map((_, index) => {
            const value = index + 1;
            return {
              label: `${pad(value)}`,
              value: `${pad(value)}`,
              index,
            };
          })
      )
      .reverse();
  }, [selectHour]);

  const optionsMintues = useMemo(() => {
    let sliceMintues = +selectHour < +today.hours ? 59 : +today.minutes;

    return [{ label: "00", value: "00" }]
      .concat(
        new Array(59)
          .fill(59)
          // .slice(0, sliceMintues)
          .map((_, index) => {
            const value = index + 1;
            return {
              label: `${pad(value)}`,
              value: `${pad(value)}`,
              index,
            };
          })
      )
      .reverse();
  }, [selectHour, selectMinute]);

  const onSyncAutoDate = async (importDatas) => {
    try {
      setLoadingImport(true);

      let listCount = 0;
      const today = new Date();
      today.setDate(today.getDate() + 1);

      let newToday = getCurrentLocalDateTime(new Date(today));
      const DOC_DATE = `${newToday.year}${pad(newToday.month)}${pad(
        newToday.date
      )}`;

      for (const importData of importDatas) {
        const data = await API.put("MoneyHubAdmin", `/fileExcel/syncAutoDate`, {
          body: {
            DOC_DATE,
            REFERENCE: importData.REFERENCE,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        });
        if (data.message === "S") {
          listCount++;
        }
      }
      console.log("list count", listCount);
      toast.success("ซิงค์ข้อมูล CSV สมบูรณ์");
      console.log("importDatas", importDatas);
    } catch (error) {
      console.log("on sync auto date", error);
    } finally {
      setLoadingImport(false);
    }
  };

  const getOption = (options, value) => {
    const findIndex = options.findIndex((option) => option.value === value);
    return options[findIndex];
  };

  const onSelectMonth = (e) => {
    const currentMonth = e;
    const diff_days = months[currentMonth.index].days - selectDate;
    if (diff_days < 0) {
      setSelectDate(`${pad(months[currentMonth.index].days)}`);
    }
    setSelectMonth(e.value);
  };

  const onSelectDate = (e) => {
    setSelectDate(e.value);
  };

  const onSelectYear = (e) => {
    setSelectYear(e.value);
  };

  const onSelectHour = (e) => {
    if (+e.value < +today.hours) {
      setSelectMinute(59);
    } else {
      const newToday = getCurrentLocalDateTime();
      setSelectMinute(pad(newToday.minutes));
    }
    setSelectHour(e.value);
  };

  const onSelectMintue = (e) => {
    setSelectMinute(e.value);
  };

  const onDeleteImportExcel = async (importDatas, fileInfo) => {
    try {
      setLoadingImport(true);
      let listFound = [];
      for (const importData of importDatas) {
        const data = await API.del("MoneyHubAdmin", `/fileExcel/syncLoan`, {
          body: {
            importData,
            username: user.username,
            // job_no: importData?.job_no,
            // fullname: importData?.name,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        });
        listFound.push(data.item);
      }
      await API.post("MoneyHubAdmin", `/fileExcel/notify`, {
        body: {
          listFound,
          username: user.username,
          importDatas,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
      await API.post("MoneyHubAdmin", `/fileExcel/historySync`, {
        body: {
          username: user.username,
          function_name: "DELETE_SYNC_LOAN",
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
      toast.success("ซิงค์ข้อมูล CSV สมบูรณ์");
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoadingImport(false);
    }
  };

  const onChangeSapCreate = (e) => {
    setSapCreate(e.target.value);
  };

  const onChangeArClear = (e) => {
    setArClear(e.target.value);
  };

  const onClickSubmit = async () => {
    try {
      setLoadingCreate(true);
      const data = await API.post("MoneyHubAdmin", `/interfaceCreateApi`, {
        body: {
          REFERENCE: 400128984,
        },
      });

      let sapItem = data[0];
      if (data.length > 1) {
        sapItem = data[1];
      }
      if (sapItem.MESSAGE_TYPE === "E") {
        await EmitterStatus("WARNING", { text: sapItem?.MESSAGE });
      } else {
        await EmitterStatus("SUCCESS", { text: sapItem?.MESSAGE });
      }
      console.log("data", data);
    } catch (error) {
      console.log("on click submit error", error);
    } finally {
      setLoadingCreate(false);
    }
  };

  const onClickSubmitArClear = async () => {
    try {
      setLoadingArClear(true);
      const data = await API.post("MoneyHubAdmin", `/arClearApi`, {
        body: {
          REFERENCE: `${arClear}`,
        },
      });

      let sapItem = data;
      if (sapItem.MESSAGE_TYPE === "E") {
        await EmitterStatus("ERROR", {
          text: `${sapItem.MESSAGE}${sapItem.MESSAGE_TYPE}`,
        });
      } else {
        await EmitterStatus("SUCCESS", {
          text: `${sapItem.MESSAGE}${sapItem.MESSAGE_TYPE}`,
        });
      }
      console.log("data", data);
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoadingArClear(false);
    }
  };

  const onSyncResend = async (importDatas = []) => {
    try {
      setLoadingImport(true);

      let listCount = 0;
      // importDatas = importDatas.slice(0, 1);
      for (const importData of importDatas) {
        const data = await API.post(
          "MoneyHubAdmin",
          `/fileExcel/importSyncPaymentReload`,
          {
            body: {
              reference1: importData.reference1,
            },
            headers: {
              Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`,
            },
          }
        );
        if (data.message === "S") {
          listCount++;
        }
      }
      console.log("list count", listCount);
      toast.success("ซิงค์ข้อมูล CSV สมบูรณ์");
    } catch (error) {
      console.log("ERROR", error);
    } finally {
      setLoadingImport(false);
    }
  };

  const onSubmitEvidence = async () => {
    const result = await Swal.fire({
      title: "คุณยืนยันที่จะอนุมัตินี้หรือไม่ ?",
      showCancelButton: true,
      confirmButtonText: `บันทึก`,
      cancelButtonText: "ยกเลิก",
      showLoaderOnConfirm: true,
      showLoaderOnDeny: false,
      preConfirm: async () => {
        try {
          const paid_date = `${selectYear}-${pad(selectMonth)}-${pad(
            selectDate
          )}T${pad(selectHour)}:${pad(selectMinute)}:${pad(today.seconds)}`;
          if (
            new Date(paid_date + "+07:00").getTime() >
            new Date(moment().format()).getTime()
          ) {
            await EmitterStatus("WARNING", {
              text: "คุณไม่สามารถเลือกวันเวลาในอนาคตได้",
            });
            return;
          }

          let errorMessage = "";
          let error = false;
          if (
            +formPayment.paid_amount === 0 ||
            !formPayment.loan_kbank_id ||
            !formPayment.transactionId
          ) {
            errorMessage = "โปรดกรอกข้อมูลให้ครบถ้วน";
            error = true;
          }

          if (error) {
            return { error, errorMessage };
          }

          const data = await API.get(
            "MoneyHubAdmin",
            `/loan/loan_kbank_id/${formPayment.loan_kbank_id}`,
            {
              headers: {
                Authorization: `Bearer ${(await Auth.currentSession())
                  .getIdToken()
                  .getJwtToken()}`,
              },
            }
          );

          if (data.type === "E") {
            return { error: true, errorMessage: "ไม่พบข้อมูลผู้ใช้งานนี้" };
          } else {
            await API.put(
              "MoneyHubAdmin",
              `/loan/evidence/${data.loan.loan_id}`,
              {
                body: {
                  paid_amount: +formPayment.paid_amount,
                  paid_date: `${selectYear}-${pad(selectMonth)}-${pad(
                    selectDate
                  )}T${pad(selectHour)}:${pad(selectMinute)}:${pad(
                    today.seconds
                  )}`,
                  adminName: user.username,
                  _id: "",
                  isNew: true,
                  bill_img: "",
                  evidence_status: "APPROVE",
                  test: true,
                  transactionId: formPayment.transactionId,
                },
                headers: {
                  Authorization: `Bearer ${(await Auth.currentSession())
                    .getIdToken()
                    .getJwtToken()}`,
                },
              }
            );
            setFormPayment(initialFormPayment);
          }
        } catch (error) {
          await EmitterStatus("ERROR", { logMessage: error });
        }
      },
    });
    if (!result.isConfirmed) return;
    if (result.value.error) {
      return await EmitterStatus("WARNING", {
        text: result.value.errorMessage,
      });
    }
    await EmitterStatus("SUCCESS");
  };

  const onChangeFormPayment = (e) => {
    const { name, value } = e.target;
    setFormPayment((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const DescriptionARClear = () => {
    return (
      <div className="flex flex-col">
        <div className="font-bold">คำอธิบาย</div>
        <div>นำเลข INTERFACE ID มายิงใหม่</div>
      </div>
    );
  };

  const Description = () => {
    return (
      <div className="flex flex-col">
        <div className="font-bold">คำอธิบาย</div>
        <div>
          เปลี่ยน sendSap จาก TRUE เป็น FALSE และเปลี่ยนวันที่ ณ ปัจจุบัน + 1
        </div>
        <div>VALUE_DATE = Today + 1 </div>
        <div>PAYMENT_POST_DATE = Today + 1 </div>
        <div>PAYMENT_DOC_DATE = Today + 1 </div>
      </div>
    );
  };

  const DescriptionDelete = () => {
    return (
      <div className="flex flex-col">
        <div className="font-bold">คำอธิบาย</div>
        <div>
          เมื่อทำการ Sync Excel ที่ระบุ{" "}
          <div className="text-red-500">Ref Index</div> ของ payment sendSap ของ
          ref นั้น ๆ True {">"} False เปลี่ยน sendSap จาก TRUE เป็น FALSE
          และเปลี่ยนวันที่ ณ ปัจจุบัน + 1
        </div>
        <div className="flex flex-col mt-4">
          <div className="text-red-500 font-bold">แก้ไขกรณี Sync Loan พลาด</div>
          <div className="font-bold">คำอธิบาย</div>
          <div>ลบ loan job number ที่ระบุ ที่ไม่มี payment</div>
          <div>ลบ accured ทิ้ง</div>
          <div>
            เปลี่ยน status loan request จาก สมบูรณ์ เป็นยืนยัน แล้วลบเลข tx ออก
          </div>
        </div>
      </div>
    );
  };

  return (
    <ContainerContent className="relative h-screen">
      <div className="mx-4 w-full mb-2 lg:flex items-center">
        {loadingImport && (
          <div className="fixed z-10 inset-0 overflow-y-auto bg-black bg-opacity-70 backdrop-filter backdrop-blur-sm flex justify-center items-center    ">
            <div className="w-2/5 h-auto mx-auto  ">
              <Lottie
                options={{
                  loop: true,
                  autoplay: true,
                  animationData: Loading,
                  isStopped: false,
                  isPaused: false,
                  rendererSettings: {
                    preserveAspectRatio: "xMidYMid slice",
                  },
                }}
              />
              <div className="text-center text-white text-xl">
                กำลัง Sync ข้อมูล CSV กับ Transactions{" "}
              </div>
            </div>
          </div>
        )}

        {checkPasswordAutoDate ? (
          <div className="mx-4 p-2 flex-col flex flex-wrap bg-gray-50 mb-2 border border-gray-200">
            <div className="flex">
              <div>Sync New AutoDate</div>
              <div className="ml-2">
                <CSVReader
                  parserOptions={importOptions}
                  onFileLoaded={onSyncAutoDate}
                />
              </div>{" "}
            </div>
            <div className="w-80 mt-2">
              <Description />
            </div>
          </div>
        ) : (
          <div className="mx-4 p-2 flex-col flex flex-wrap bg-gray-50 mb-2 border border-gray-200">
            <div className="flex ">
              <div>Sync New AutoDate</div>
              <div className="flex ml-2"></div>

              <div>Auto Date</div>
              <input
                className="border border-gray-400 ml-2"
                type="password"
                value={passwordAutoDate}
                onChange={(e) => {
                  setPasswordAutoDate(passwordAutoDate);
                  if (e.target.value === "1112") {
                    setCheckPasswordAutoDate(true);
                  }
                }}
              />
            </div>{" "}
            <div className="w-80 mt-2">
              <Description />
            </div>
          </div>
        )}

        {checkPassword ? (
          <div className="mx-4 flex-col flex flex-wrap bottom-0 right-0 absolute p-2 lg:flex bg-gray-50 mb-8 mr-8 border border-red-500">
            <div className="flex">
              <div>Sync Delete Loan</div>
              <div className="ml-2">
                <CSVReader
                  parserOptions={importOptions}
                  onFileLoaded={onDeleteImportExcel}
                />
              </div>{" "}
            </div>
            <div className="w-80 mt-2">
              <DescriptionDelete />
            </div>
          </div>
        ) : (
          <div className="mx-4 flex-col flex flex-wrap bottom-0 right-0 absolute p-2 lg:flex bg-gray-50 mb-8 mr-8 border border-red-500">
            <div className="flex">
              <div>Sync Delete Loan</div>
              <div className="flex ml-2">
                <div>Password</div>
                <input
                  className="border border-gray-400 ml-2"
                  type="password"
                  value={passwordSyncDelete}
                  onChange={(e) => {
                    setPasswordSyncDelete(passwordSyncDelete);
                    if (e.target.value === "2112") {
                      setCheckPassword(true);
                    }
                  }}
                />
              </div>{" "}
            </div>
            <div className="w-80 mt-2">
              <DescriptionDelete />
            </div>
          </div>
        )}
      </div>
      <div className="mx-4 w-full mb-2 lg:flex items-center">
        {/* <div className="mx-4 flex items-center p-2 lg:flex bg-gray-50 mb-2 border border-gray-200">
          <div>Interface Create</div>
          <input
            className="border border-gray-400 ml-2"
            value={sapCreate}
            onChange={onChangeSapCreate}
            type={"text"}
          />
          <button
            disabled={loadingCreate}
            onClick={onClickSubmit}
            className={classNames(
              `ml-2 border p-1 px-2 rounded text-white  duration-300 `,
              {
                "hover:bg-green-600 bg-green-500 cursor-pointer":
                  !loadingCreate,
                "text-white bg-gray-200": loadingCreate,
              }
            )}
          >
            {loadingCreate ? "Loading..." : "Submit"}
          </button>
        </div> */}

        {checkPasswordArClear ? (
          <div className="mx-4 flex flex-col items-center p-2 lg:flex bg-gray-50 mb-2 border border-gray-200">
            <div className="flex">
              <div>AR Clear</div>
              <input
                className="border border-gray-400 ml-2"
                value={arClear}
                onChange={onChangeArClear}
                type={"text"}
              />
              <button
                disabled={loadingArClear}
                onClick={onClickSubmitArClear}
                className={classNames(
                  `ml-2 border p-1 px-2 rounded text-white  duration-300 `,
                  {
                    "hover:bg-green-600 bg-green-500 cursor-pointer":
                      !loadingArClear,
                    "text-white bg-gray-200": loadingArClear,
                  }
                )}
              >
                {loadingArClear ? "Loading..." : "Submit"}
              </button>
            </div>
            <div className="w-80 mt-2">
              <DescriptionARClear />
            </div>
          </div>
        ) : (
          <div className="mx-4 flex flex-col items-center p-2 lg:flex bg-gray-50 mb-2 border border-gray-200">
            <div className="flex">
              <div>AR Clear</div>
              <div className="flex ml-2">
                <div>Password</div>
                <input
                  className="border border-gray-400 ml-2"
                  type="password"
                  value={passwordArClear}
                  onChange={(e) => {
                    setPasswordArClear(e.target.value);
                    if (e.target.value === "1112") {
                      setCheckPasswordArClear(true);
                    }
                  }}
                />
              </div>{" "}
            </div>
            <div className="w-80 mt-2">
              <DescriptionARClear />
            </div>
          </div>
        )}
      </div>

      <div className="ml-8 w-72  p-2 lg:flex bg-gray-50 mb-2 border border-gray-200">
        <div>Sync Resend</div>
        <div className="ml-2">
          <CSVReader
            parserOptions={importOptions}
            onFileLoaded={onSyncResend}
          />
        </div>{" "}
      </div>

      <div className="ml-8 w-1/3 p-2 lg:flex bg-gray-50 mb-2 border border-gray-200 flex flex-col">
        <div>จ่ายเงินย้อนหลัง</div>
        <div className="flex flex-col">
          <div className="w-full text-left text-gray-700 text-base mt-2">
            Reference
          </div>
          <input
            type="text"
            className="w-full mt-0 p-1 border border-gray-300 rounded"
            onChange={onChangeFormPayment}
            name="loan_kbank_id"
            value={formPayment.loan_kbank_id}
            placeholder="500613292"
          />
          <div className="w-full text-left text-gray-700 text-base mt-2">
            TransactionID
          </div>
          <input
            type="text"
            className="w-full mt-0 p-1 border border-gray-300 rounded"
            onChange={onChangeFormPayment}
            name="transactionId"
            value={formPayment.transactionId}
          />
          <div className="w-full text-left text-gray-700 text-base mt-2">
            ยอดเงิน
          </div>
          <input
            type="text"
            className="w-full mt-0 p-1 border border-gray-300 rounded"
            onChange={onChangeFormPayment}
            name="paid_amount"
            value={formPayment.paid_amount}
          />
          <div className="w-full text-left text-gray-700 text-base">
            วัน/เวลา ที่ชำระ
          </div>

          <div className="w-full grid grid-cols-12 gap-1 ">
            <div className="col-span-2">
              <div className="text-left">Date</div>
              <Select
                options={optionsDates}
                value={{
                  label: `${pad(selectDate)}`,
                  value: `${pad(selectDate)}`,
                }}
                onChange={(e) => onSelectDate(e)}
              />
            </div>
            <div className="col-span-3">
              <div className="text-left">Month</div>
              <Select
                options={optionsMonths}
                value={{
                  label: `${pad(selectMonth)}`,
                  value: `${pad(selectMonth)}`,
                }}
                onChange={(e) => onSelectMonth(e)}
              />
            </div>
            <div className="col-span-3">
              <div className="text-left">Year</div>
              <Select
                options={optionsYears}
                value={{
                  label: selectYear,
                  value: selectYear,
                }}
                onChange={(e) => onSelectYear(e)}
              />
            </div>
            <div className="col-span-2">
              <div className="text-left">Hour</div>
              <Select
                options={optionsHours}
                value={{
                  label: `${pad(selectHour)}`,
                  value: `${pad(selectHour)}`,
                }}
                onChange={(e) => onSelectHour(e)}
              />
            </div>
            <div className="col-span-2">
              <div className="text-left">Minutes</div>
              <Select
                options={optionsMintues}
                value={{
                  label: `${pad(selectMinute)}`,
                  value: `${pad(selectMinute)}`,
                }}
                onChange={(e) => onSelectMintue(e)}
              />
            </div>
          </div>
          <button
            onClick={onSubmitEvidence}
            className="mt-2 px-4 py-1 w-full rounded text-white text-sm shadow-sm duration-300 transition-all focus:outline-none bg-green-500 hover:bg-green-600"
          >
            อนุมัติ
          </button>
        </div>
      </div>
    </ContainerContent>
  );
}

export default SapMain;
